import Button from 'components/Button';
import { Stack } from 'components/Stack';
import { useDetectDevice } from 'hooks/useDetectDevice';
import { useTranslation } from 'react-i18next';
import HelperText from 'components/HelperText';
import { Container } from './ModalFooter.styles';
import { STEPS } from '../../constants/ReturnRequest.constant';

interface ModalFooterProps {
  currentStep: string;
  onCloseModal: () => void;
  goToEditMode: () => void;
  handleNextButton: () => void;
  handleConfirmButton: () => void;
  error: string;
  isConfirming: boolean;
}

const ModalFooter = ({
  currentStep,
  onCloseModal,
  goToEditMode,
  handleNextButton,
  handleConfirmButton,
  error,
  isConfirming,
}: ModalFooterProps): JSX.Element => {
  const { t } = useTranslation();
  const { isMobile } = useDetectDevice();
  return (
    <Container
      direction={isMobile ? 'column' : 'row'}
      justify="space-between"
      align="center"
      gap={8}
    >
      <HelperText isError size="lg">
        {error}
      </HelperText>
      <Stack
        direction={isMobile ? 'column' : 'row'}
        justify="space-between"
        gap={8}
        isFullWidth={isMobile}
      >
        {currentStep === STEPS.EDIT && (
          <>
            <Button onClick={onCloseModal} block={isMobile} variant="outlined">
              {t('CANCEL_CTA')}
            </Button>
            <Button
              onClick={handleNextButton}
              block={isMobile}
              variant="fulfilled"
            >
              {t('NEXT_CTA')}
            </Button>
          </>
        )}
        {currentStep === STEPS.VIEW && (
          <>
            <Button onClick={goToEditMode} block={isMobile} variant="outlined">
              {t('BACK_CTA')}
            </Button>
            <Button
              disabled={isConfirming}
              onClick={handleConfirmButton}
              block={isMobile}
              variant="fulfilled"
            >
              {t('CONFIRM_CTA')}
            </Button>
          </>
        )}
      </Stack>
    </Container>
  );
};

export { ModalFooter };
